export interface ClientLogo {
  name: string
  src: string
}

export const clientLogos: ClientLogo[] = [
  { name: 'Partenord Habitat', src: 'https://cdn.magicpatterns.com/uploads/hdBaWn1LqW8D1fkDfJQz6h/image_18_(3).png' },
  { name: 'WYZ group', src: 'https://cdn.magicpatterns.com/uploads/j143YdGdLvkuzgn97a9aPB/image_19.png' },
  { name: 'ENGIE', src: 'https://cdn.magicpatterns.com/uploads/3iRtrz76DBJx6YLAE3ZzKk/image_21.png' },
  { name: 'E.Leclerc', src: 'https://cdn.magicpatterns.com/uploads/jRhip763f9GZzFa7H3W25n/image_23.png' },
  { name: 'St Maclou', src: 'https://cdn.magicpatterns.com/uploads/pnR1LVQ1hqhn51DXpVqdhY/image_22.png' },
  { name: 'Outsourcia', src: 'https://cdn.magicpatterns.com/uploads/iBB9hKxiXKn18D5ajnpNLc/image_24.png' }
]
